const choiceSequenceHandler = {
    sortAlternativesAccordingToChoiceSequence(alternatives, sequenceArray) {
        alternatives.forEach((choice) => {
            choice.index = sequenceArray.indexOf(choice.identifier);
        });

        alternatives.sort((a, b) => {
            return a.index - b.index;
        });
    },
};

export default choiceSequenceHandler;
